import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import SchoolLogo from "../components/SchoolLogo";

/**
 * Public scan-redirect endpoint. The QR code embeds a token; this page
 * routes the user appropriately:
 *  - If org_admin is logged in: send to scanner (token NOT auto-submitted; they must select event).
 *  - Otherwise: show "Unauthorized" and direct them to login.
 */
export default function ScanRedirect() {
  const { token } = useParams();
  const { user } = useAuth();

  if (user === undefined) return null;

  if (user?.role === "org_admin") {
    return <Navigate to={`/org/scanner?token=${encodeURIComponent(token)}`} replace />;
  }

  return (
    <div className="min-h-screen bg-[#F4F6F5] grid place-items-center p-6">
      <div
        className="max-w-md w-full bg-white border border-[#E3E6E4] rounded-lg p-8 shadow-sm"
        data-testid="unauthorized-card"
      >
        <div className="flex items-center gap-3 mb-5 pb-4 border-b border-[#E3E6E4]">
          <SchoolLogo size={36} />
          <div className="leading-tight">
            <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#05126E]">
              Attendance System
            </div>
            <div className="text-sm font-extrabold text-[#0f1a14]">
              GANAP INC.
            </div>
          </div>
        </div>
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#B91C1C] mb-2">
          401 · Unauthorized
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight mb-3 text-[#0f1a14]">
          Scanner restricted
        </h1>
        <p className="text-sm text-[#5a6663] mb-6">
          QR codes can only be scanned by Org Admins of GANAP INC.
          Sign in with an admin account to record attendance.
        </p>
        <a
          href="/login"
          className="inline-block px-5 py-2.5 rounded-md bg-[#05126E] text-white font-semibold hover:bg-[#030B45] transition-colors"
          data-testid="go-login-btn"
        >
          Sign in
        </a>
      </div>
    </div>
  );
}
